// import {} from "react";

import { gql } from "apollo-boost";
import { useQuery, useMutation } from "@apollo/react-hooks";

const query = gql`
  query getHelps {
    getHelpTypes {
      id
      type
      title
      excerpt
      description
      status
    }
  }
`;

const querySingle = gql`
  query getHelpType($id: String!) {
    getHelpType(id: $id) {
      id
      title
      description
      status
    }
  }
`;

const mutationCreate = gql`
  mutation createHelp(
    $description: String!
    $ticket_id: String
    $type_id: String!
  ) {
    createHelp(
      description: $description
      ticket_id: $ticket_id
      type_id: $type_id
    ) {
      created_at
      status
    }
  }
`;

const fetchPolicy = "no-cache";

export const useHelps = () => {
  return useQuery(query, {
    fetchPolicy,
  });
};

export const useHelp = (id?: string) => {
  return useQuery(querySingle, {
    variables: { id },
    fetchPolicy,
  });
};

export const useHelpCreate = () => {
  return useMutation(mutationCreate);
};
